import React, { useState } from "react";
import Modal from "react-modal";
import cals from '../assets/icons/0 Calories.svg';

Modal.setAppElement("#root");

const Labels = ({ LabelsData }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            {/* Trigger button */}
            <div
                style={{
                    margin: "0px 25px 0px 0px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                }}
                onClick={() => setModalOpen(true)}
            >
                <div
                    style={{
                        height: 'fit-content',
                        minHeight: "35px",
                        width: 'fit-content',
                        fontSize: "16px",
                        fontWeight: 600,
                        display: "flex",
                        flexWrap: 'wrap',
                        alignItems: "center",
                        gap: "6px",
                        color: "#001E3A",
                        borderRadius: '25px',
                        padding: "5px 25px",
                        lineHeight: '15px',
                        border: "0.75px solid #001E3A50",
                        backgroundColor: '#FFFFFF'
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="21px" viewBox="0 -960 960 960" width="21px" fill="#001E3A"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h440q19 0 36 8.5t28 23.5l216 288-216 288q-11 15-28 23.5t-36 8.5H160Zm0-80h440l180-240-180-240H160v480Zm220-240Z" /></svg>
                    Glossary
                </div>
            </div>

            {/* Modal */}
            <Modal
                isOpen={modalOpen}
                onRequestClose={() => setModalOpen(false)}
                style={{
                    overlay: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        zIndex: 9999,
                    },
                    content: {
                        width: "94vw",
                        Height: 'fit-content',
                        maxHeight: "70vh",
                        inset: "10vh 3vw 3vw 3vw",
                        borderRadius: "15px",
                        padding: "60px 0px 25px 0px",
                        overflowY: "auto",
                        position: "relative",
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center'
                    },
                }}
            >

                {/* Close Button */}
                <div
                    style={{
                        fontSize: "20px",
                        lineHeight: "20px",
                        textAlign: "left",
                        cursor: "pointer",
                        marginBottom: "12px",
                        color: "#001E3A",
                        position: 'absolute',
                        top: '25px',
                        left: "20px"
                    }}
                    onClick={() => setModalOpen(false)}
                >
                    Labels Glossary
                </div>

                {/* Close Button */}
                <div
                    style={{
                        cursor: "pointer",
                        marginBottom: "12px",
                        color: "#001E3A",
                        position: 'absolute',
                        top: '15px',
                        right: "15px",
                        rotate: '45deg'
                    }}
                    onClick={() => setModalOpen(false)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="35px" viewBox="0 -960 960 960" width="35px" fill="#001E3A"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" /></svg>
                </div>

                {/* Labels */}
                <div style={{
                    width: "85vw",
                    display: "grid",
                    gridTemplateColumns: "40vw 40vw",
                    columnGap: "0vw",
                    fontSize: "x-small",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: "6px",
                }}>
                    {LabelsData &&
                        Object.keys(LabelsData).map((Label) => (
                            <span
                                key={Label}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: 'none',
                                    userSelect: 'auto'
                                }}
                            >
                                <img src={LabelsData[Label].URL} alt={LabelsData[Label][0]} style={{
                                    width: "18px",
                                    height: "18px",
                                    objectFit: "contain",

                                }} />
                                &nbsp;-&nbsp;
                                {LabelsData[Label].Label}
                            </span>
                        ))}
                        <span
                                key={cals}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: 'none',
                                    userSelect: 'auto'
                                }}
                            >
                                <img src={cals} alt={cals} style={{
                                    width: "18px",
                                    height: "18px",
                                    objectFit: "contain",

                                }} />
                                &nbsp;-&nbsp;
                                Calories
                            </span>
                </div>
            </Modal >
        </>
    );
};

export default Labels;
